import { CalloutBox } from 'components/Docs/CalloutBox';
import { ProductScreenshot } from 'components/ProductScreenshot';
import * as React from 'react';
export default {
  CalloutBox,
  ProductScreenshot,
  React
};